<template>
  <div class="wDetailApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">

    <div class="writeContent">
      <h2>{{setNews.title}}</h2>
      <div class="read">
        <span>浏览量：{{setNews.read}}</span>
        <span>分享来源<font>{{setNews.soure}}</font></span>
      </div>

      <div class="con">
      <div v-html="setNews.content"></div> 
      </div>

      <div class="users" v-if="user.length > 0">
        <h2>查看人员</h2>
        <ul>
          <li v-for="(item,i) in user">
            <img :src="item.avatar == '' ? avatar : baseUrl+item.avatar"/>
            <div class="info">
              <p>{{item.username}}</p>
              <p>{{item.phone}}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>

    
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: true,
        setNews:[],
        baseUrl:'',
        user:[],
        avatar:require( '../../assets/images/logo.png'),
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      if(localStorage.getItem('userjwt') == null){
        this.open()
      }
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    mounted() {
      this.beforeMount();
      this.detail();
    },

    methods: {
      detail:function(e){
        var id = this.$route.query.id;
        var that = this;
        this.axios({
          'url': that.$host+'wx/news/shareDetail',
          'method': 'post',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data.data;
          that.setNews = res.rs;
          that.user = res.user;
          document.title = res.rs.title;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },
      jump:function(index,url){
        this.$router.push({
          path:url,
          query:{
           id:index
         }
        })
      },
      open:function() {
        this.$alert('请先登录！', '警告', {
          confirmButtonText: '确定',
          showClose:false,
          callback: action => {
            var url = encodeURIComponent('http://user.laife.cn/main/login');
            window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf57bae009c299252&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
            return;
          }
        });
      },
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .wDetailApp{
    max-width:640px;
    background:#fff;
    margin:0 auto;
  }
  .wDetailApp .writeContent{
    display:block;
    width:92%;
    margin:0 auto;
    padding-bottom:65px
  }
  .wDetailApp .writeContent h2{
    font-size:18px;
    padding:15px 0 10px 0;
  }
  .wDetailApp .writeContent .read:after{
    display:block;
    clear:both;
    content:"";
    visibility:hidden;
    height:0;
  }
  .wDetailApp .writeContent .read span{
    float:left;
    font-size:14px;
    color:#7f8995
  }
  .wDetailApp .writeContent .read span:last-child{
    float:right;
    width:70%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .wDetailApp .writeContent .read span font{
    color:#333;
    padding-left:5px;
    font-weight:bold;

  }
  .wDetailApp .writeContent .con{
    padding-top:15px;
  }
  .wDetailApp .writeContent .con div{
    visibility: visible !important;
  }
  .wDetailApp .writeContent .con img{
    display:block;
    width:100% !important;
    margin:15px 0 ;
  }
  .wDetailApp .writeContent .con p,.wDetailApp .writeContent .con span{
    font-size:16px;
    color:#0d2148;
    line-height:22px;
    margin-bottom:10px;
    display:block;
    letter-spacing: 1px
  }
  .wDetailApp .users h2{
    font-size:18px;
    color:#007ae6;
  }
  .wDetailApp .users ul{
    display: flex;
    margin: 0 auto;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
  }
  .wDetailApp .users ul li{
    width: 48%;
    margin-top: 15px;
    margin-bottom: 5px
  }
  .wDetailApp .users li img{
    float:left;
    width:60px;
    border-radius:50%;
  }
  .wDetailApp .users li div{
    float:left;
    margin-top:3px;
    margin-left:5px
  }
  .wDetailApp .users li div p{
    display:block;
    font-size:15px;
    color:#000;
    padding-top:5px
  }
</style>